<template>
    <div class="main" v-loading.fullscreen="isLoad" element-loading-background="rgba(0, 0, 0,0)">
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>订单管理</el-breadcrumb-item>
            <el-breadcrumb-item>订单汇总</el-breadcrumb-item>
        </el-breadcrumb>
        <el-form :inline="true" :model="filter" class="search">
            <el-row>
                <el-form-item label="订单类型">
                    <el-radio-group v-model="filter.order_source" @change="submit">
                        <el-radio-button label="0">全部订单</el-radio-button>
                        <el-radio-button label="10">普通订单</el-radio-button>
                        <el-radio-button label="30">秒杀订单</el-radio-button>
                        <el-radio-button label="-1">赠品订单</el-radio-button>
                    </el-radio-group>
                </el-form-item>
            </el-row>
            <el-row>
                <el-form-item label="订单状态">
                    <el-radio-group v-model="filter.order_status" @change="submit">
                        <el-radio-button label="0">全部</el-radio-button>
                        <el-radio-button label="1" name="1">待付款</el-radio-button>
                        <el-radio-button label="2" name="2">待发货</el-radio-button>
                        <el-radio-button label="3" name="3">待收货</el-radio-button>
                        <el-radio-button label="4" name="4">已完成</el-radio-button>
                        <el-radio-button label="5" name="5">用户取消</el-radio-button>
                        <el-radio-button label="6" name="6">系统取消</el-radio-button>
                    </el-radio-group>
                </el-form-item>
            </el-row>
            <el-row>
                <el-form-item label="支付方式">
                    <el-radio-group v-model="filter.pay_type" @change="submit">
                        <el-radio-button label="0">全部</el-radio-button>
                        <el-radio-button label="1" name="1">微信支付</el-radio-button>
                        <el-radio-button label="2" name="2">积分支付</el-radio-button>
                    </el-radio-group>
                </el-form-item>
            </el-row>
            <el-form-item label="订单搜索">
                <el-input v-model="filter.real_name" placeholder="订单号/用户昵称/用户ID/手机号" size="small"></el-input>
            </el-form-item>
            <el-form-item label="订单来源">
                <el-cascader v-model="filter.supplier_id" :options="options"
                     :props="props" size="small"
                     clearable></el-cascader>
            </el-form-item>
            <el-form-item label="时间">
                <el-date-picker size="small" style="margin-left: 10px" v-model="filter.times" type="daterange"
                    range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss">
                </el-date-picker>
            </el-form-item>
            <el-form-item>
                    <el-button type="primary" @click="submit" size="medium">查询</el-button>

                 <el-button type="success" @click="excelOut" size="medium">导出</el-button>
            </el-form-item>
        </el-form>
        <table class="table" width="100%" cellpadding="0" cellspacing="0">
            <tr>
                <th>商品</th>
                <th>数量</th>
                <th>来源</th>
                <th>买家</th>
                <th>实付款</th>
                <th>支付方式</th>
                <th>状态</th>
                <th>操作</th>
            </tr>
            <template v-for="item in list">
                <tr>
                    <th colspan="8">
                        <div class="dis-flex flex-x-between">
                            <div>{{item.created_date}} 订单编号：{{item.order_sn}}</div>
                            <div v-if="item.dealerOrder">
                                <div v-if="item.dealerOrder.dealer_first">一级分销：{{item.dealerOrder.dealer_first.user.nick_name || ''}}</div>
                                <div v-if="item.dealerOrder.dealer_second">二级分销：{{item.dealerOrder.dealer_second.user.nick_name || ''}}</div>
                                <div v-if="item.dealerOrder.dealer_third">三级分销：{{item.dealerOrder.dealer_third.user.nick_name || ''}}</div>
                            </div>
                        </div>


                    </th>
                </tr>
                <tr v-for="(val , key) in item.goods">
                    <td>
                        <div class="thumb">
                            <img :src="val.pic_url">
                            {{val.product_name}}（{{val.sku_name}}）
                        </div>
                    </td>
                    <td>
                        {{val.number}} 件
                    </td>
                    <td>
                        {{val.supplier_id ? (val.supplier ? val.supplier.name : '非自营') : '自营'}}
                    </td>
                    <template v-if="!key">
                        <td>
                            {{item.buyer ? item.buyer.nick_name : ''}}
                            {{item.buyer ? item.buyer.mobile : ''}}

                            <p>收货人：<span class="color-blue">{{item.consignee}}</span></p>
                            <p>买家手机：<span>{{item.mobile}}</span>
                            <p>收货地址：<span class="color-blue">{{item.address}}</span>
                            </p>
                        </td>
                        <td>
                            <el-tag size="small">{{item.actual_price}} 元</el-tag><br>
                        </td>
                        <td>
                            {{item.pay_type == 1 ? '微信支付' : '积分支付'}}
                        </td>
                        <td>
                            <el-tag size="small" type="info" effect="dark" v-if="item.order_status == 1">待付款</el-tag>
                            <template v-else-if="item.order_status == 2">
                                <el-tag size="small" type="warning" effect="dark">待发货
                                </el-tag>
                            </template>
                            <el-tag size="small" effect="dark" v-else-if="item.order_status == 3">待收货</el-tag>
                            <el-tag size="small" type="success" effect="dark" v-else-if="item.order_status == 4">已完成
                            </el-tag>
                            <el-tag size="small" type="info" effect="dark" v-else-if="item.order_status == 5">用户取消
                            </el-tag>
                            <el-tag size="small" type="info" effect="dark" v-else-if="item.order_status == 6">系统取消
                            </el-tag>
                            <el-tag size="small" type="danger" effect="dark" v-else>退款申请中</el-tag>
                        </td>
                        <td>
                            <el-button size="mini" type="default" @click="open(item.id)" v-if="item.order_status == 2 && item.supplier_id == 0">
                                发货
                            </el-button>
                            <el-button size="mini" type="primary" @click="edit(item.id)">查看</el-button>
                            <el-button size="mini" type="primary" @click="confirmcancel(item.id)"  v-if="item.order_status == 21 && item.supplier_id == 0" v-auth="['store/order/confirmCancel']">去审核</el-button>
                        </td>
                    </template>
                </tr>
                <tr v-for="(val , key) in item.gives">
                    <td>
                        <div class="thumb">
                            <img :src="val.pic_url">
                            {{val.product_name}}（{{val.sku_name}}）
                        </div>
                    </td>
                    <td>
                        {{val.number}} 件
                    </td>
                    <td>
                        赠品
                    </td>
                    <template v-if="!key">
                        <td>
                        </td>
                        <td>
                        </td>
                        <td>
                        </td>
                        <td>
                            <el-tag size="small" type="info" effect="dark" v-if="item.order_status == 1">待付款</el-tag>
                            <block v-else-if="item.order_status == 2">
                                <el-tag size="small" type="warning" effect="dark">待发货
                                </el-tag>
                            </block>
                            <el-tag size="small" effect="dark" v-else-if="item.order_status == 3">待收货</el-tag>
                            <el-tag size="small" type="success" effect="dark" v-else-if="item.order_status == 4">已完成
                            </el-tag>
                            <el-tag size="small" type="info" effect="dark" v-else-if="item.order_status == 5">用户取消
                            </el-tag>
                            <el-tag size="small" type="info" effect="dark" v-else-if="item.order_status == 6">系统取消
                            </el-tag>
                            <el-tag size="small" type="danger" effect="dark" v-else>退款申请中</el-tag>
                        </td>
                        <td>
                            <el-button size="mini" type="default" @click="open(item.id)" v-if="item.order_status == 2 && item.supplier_id == 0">
                                发货
                            </el-button>
                            <el-button size="mini" type="primary" @click="edit(item.id)">查看</el-button>
                            <el-button size="mini" type="primary" @click="confirmcancel(item.id)"  v-if="item.order_status == 21 && item.supplier_id == 0" v-auth="['store/order/confirmCancel']">去审核</el-button>
                        </td>
                    </template>
                </tr>
            </template>
        </table>
        <el-pagination @size-change="sizeReload" @current-change="pageReload" :current-page="page"
                       :page-sizes="[20, 100, 200, 300, 400]" :page-size="pageSize"
                       layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
        <el-dialog title="订单发货" :visible.sync="dialogFormVisible">
            <el-form label-position="right" :model="form" label-width="auto">
                <el-form-item label="收货人" v-if="order">
                    {{order.consignee}}
                </el-form-item>
                <el-form-item label="买家手机"  v-if="order">
                    {{order.mobile}}
                </el-form-item>
                <el-form-item label="收货地址"  v-if="order">
                    {{order.address}}
                </el-form-item>
                <el-form-item label="物流公司">
                    <el-select v-model="form.express_id" clearable placeholder="请选择物流公司">
                        <el-option v-for="item in express" :value="item.id" :label="item.express_name"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="物流单号">
                    <el-input clearable v-model="form.express_sn" placeholder="请输入物流单号"/>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取消</el-button>
                <el-button type="primary" @click="send" v-auth="['store/order/sendShip']">发货</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    import axios from "axios";

    export default {
        data() {
            return {
                form: {},
                dialogFormVisible: false,
                isLoad: true,
                express: [],
                list: [],
                pageSize: 20,
                total: 0,
                page: 1,
                // 查询
                filter: {
                    order_status: 0,
                    pay_type: 0,
                    order_source: 0
                },
                options: [{
                    id: -1,
                    name: '自营',
                }, {
                    id: -2,
                    name: '非自营',
                    children: []
                }],
                supplier_id: '',
                order: false,
                props: { checkStrictly: true, label: 'name',value:'id' }
            }
        },
        created() {
            this.loadSuppliers()
            this.loadData()
        },
        methods: {
            async loadSuppliers () {
                // 供应商列表
                res = await this.axios.get('/store/data/listSupplierForOrderSearch', {})
                this.$set(this.options[1], 'children', res.data.list)
            },
            open(id) {
                this.isLoad = !this.isLoad
                this.axios.get('/store/order/detail', {
                    params: {
                        id: id
                    }
                }).then(res => {
                    this.isLoad = !this.isLoad
                    this.form = {
                        id: id,
                        goods: res.data.detail.goods
                    }
                    this.order = res.data.detail
                    this.dialogFormVisible = true
                })
            },
            loadData() {
                this.axios.post('/store/data/listLogisticsForSelect').then(res => {
                    this.isLoad = !this.isLoad
                    this.express = res.data.list
                    this.loadList()
                }).catch(() => {
                    this.isLoad = !this.isLoad
                })
            },
            async send() {
                // this.isLoad = !this.isLoad
                let res = ''
                try {
                    var _this = this
                    this.axios.post('/store/order/sendShip', {
                        id: this.form.id,
                        form: {
                            express_id: this.form.express_id,
                            express_company: this.form.express_id ? (this.express.find(function (item) {
                                return _this.form.express_id == item.id
                            })).express_name : '',
                            express_sn: this.form.express_sn
                        }
                    }).then(res => {
                        this.isLoad = false
                        this.$message.success({
                            message: '发货成功'
                        });
                        this.dialogFormVisible = false
                        this.loadList()
                    }) .catch((e) => {
                        this.isLoad = false
                    })
                } catch (res) {
                }

            },
            async loadList() {
                if (this.isLoad)
                    return
                this.isLoad = !this.isLoad
                let res = ''

                res = await this.axios.get('/store/order/list', {
                    params: this.filter
                })
                this.list = res.data.list.data
                this.total = res.data.list.total

                this.isLoad = !this.isLoad
            },
            // 传一个ID跳转到edit页面，进行编辑
            edit(id) {
                this.$router.push({
                    path: '/Indent/list.html',
                    query: {
                        id: id
                    }
                });
            },
            sizeReload(val) {
                this.filter.pageSize = val
                this.loadList()
            },
            pageReload(val) {
                this.filter.page = val
                this.loadList()
            },
            // 搜索查询
            submit() {
                this.page = 1
                this.loadList()
            },
            confirmcancel: function (id) {
                this.$router.push({
                    path: '/Indent/list.html#cancel',
                    query: {
                        id: id
                    }
                });
            },
            // 导出
            excelOut1() {
                if (this.isLoad) {
                    return false
                }

                this.isLoad = !this.isLoad
                setTimeout(function () {
                    this.isLoad = false
                }.bind(this), 100000);
                this.axios.post('/store/order/listExport', this.filter)
                    .then(res => {
                        this.isLoad = false
                        if (res.code == 1) {
                            import('@/vendor/Export2Excel.js').then(excel => {
                                var expCellName = res.data.expCellName
                                var tHeader = []
                                var filterVal = []
                                for (var i in expCellName) {
                                    tHeader.push(expCellName[i])
                                    filterVal.push(i)
                                }
                                const expTableData = res.data.expTableData
                                const data = this.formatJson(filterVal, expTableData)
                                var d = new Date()
                                var year = d.getFullYear()
                                var month = d.getMonth()
                                var date = d.getDate()
                                var hour = d.getHours()
                                var minute = d.getMinutes()
                                var second = d.getSeconds()
                                month = month < 10 ? '0' + month : month
                                date = date < 10 ? '0' + date : date
                                hour = hour < 10 ? '0' + hour : hour
                                minute = minute < 10 ? '0' + minute : minute
                                second = second < 10 ? '0' + second : second
                                excel.export_json_to_excel({
                                    header: tHeader,
                                    data,
                                    filename: '订单导出_' + year + '' + month + '' + date + '' + hour + '' + minute + '' + second,
                                    autoWidth: this.autoWidth,
                                    bookType: this.bookType
                                })
                            })
                        } else {
                            this.$message({
                                message: res.msg,
                                type: 'error',
                                duration: 3 * 1000
                            })
                        }
                    })
            },
            excelOut() {
                if (this.isLoad) {
                    return false
                }

                this.isLoad = !this.isLoad
                setTimeout(function () {
                    this.isLoad = false
                }.bind(this), 100000);
                this.axios.defaults.baseURL = 'http://xfl.jm.xm0592.com'
                this.axios.post('/api/test/export', this.filter)
                    .then(res => {
                        this.isLoad = false
                        if (res.code == 1) {
                            import('@/vendor/Export2Excel.js').then(excel => {
                                var expCellName = res.data.expCellName
                                var tHeader = []
                                var filterVal = []
                                for (var i in expCellName) {
                                    tHeader.push(expCellName[i])
                                    filterVal.push(i)
                                }
                                const expTableData = res.data.expTableData
                                const data = this.formatJson(filterVal, expTableData)
                                var d = new Date()
                                var year = d.getFullYear()
                                var month = d.getMonth()
                                var date = d.getDate()
                                var hour = d.getHours()
                                var minute = d.getMinutes()
                                var second = d.getSeconds()
                                month = month < 10 ? '0' + month : month
                                date = date < 10 ? '0' + date : date
                                hour = hour < 10 ? '0' + hour : hour
                                minute = minute < 10 ? '0' + minute : minute
                                second = second < 10 ? '0' + second : second
                                excel.export_json_to_excel({
                                    header: tHeader,
                                    data,
                                    filename: '订单导出_' + year + '' + month + '' + date + '' + hour + '' + minute + '' + second,
                                    autoWidth: this.autoWidth,
                                    bookType: this.bookType
                                })
                            })
                        } else {
                            this.$message({
                                message: res.msg,
                                type: 'error',
                                duration: 3 * 1000
                            })
                        }
                    })
            },
            formatJson (filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => {
                    return v[j]
                }))
            },
        },
    }
</script>
<style scoped>
    .table {
        width: 100%;
        border-collapse: collapse;
    }

    .table td {
        border: 1px solid #EBEEF5;
        padding: 12px 10px;
        color: rgb(96, 98, 102);
        line-height: 23px;
    }

    .table th {
        line-height: 23px;
        border: 1px solid #EBEEF5;
        padding: 12px 10px;
        text-align: left;
        background: #f5f7fa;
        color: rgb(144, 147, 153);
    }
</style>
